import React from 'react';

import Input from './Input';
import Tag from './Tag';


import loupe from '../../assets/icons/loupe.svg';

const DogHero = (props) => {
    return (
        <div id={props.id ? props.id : ''} className="dog-hero">
            <div className="dog-hero__container">
                <h1 className="dog-hero__container__title">
                    {props.titleLeft} <span className="text-white"> {props.titleHighlight} </span> {props.titleRight}
                </h1>
                {props.subtitle ?
                    <h2 className="dog-hero__container__subtitle">
                        {props.subtitle}
                    </h2>
                : null}
                {props.inputHidden ? null : <Input icon={loupe} containerClasses="dog-hero__container__input-container" iconClasses="dog-hero__container__icon" inputClasses="dog-hero__container__input" placeholder={props.inputPlaceholder} />}
                
                 {props.tags?.length ?
                    <div className="dog-hero__container__popular">
                        Popular:
                    {props.tags && props.tags.map(tag => {
                        return <Tag key={tag.id} name={tag.name} />
                    })}
                    </div>
                : null}
            
            </div>
            {props.dog ? <img src={props.dog} alt="dog" className="dog-hero__dog" /> : null}
        </div>
    );
}

export default DogHero;